import { STATUS } from '@front-app/constants/state';
import { EventV2 } from '@front-app/services/EventsApi/EventModel';
import { getGroupEvents } from '@front-app/services/GroupsApi/GroupsEventsApi';
import { Ref, ref, watch } from '@vue/composition-api';
import { CancelToken } from 'axios';
import { useThrottledApi } from '../ThrottledApi/useThrottledApi';
import { useAsyncStatus } from '../useAsyncStatus';

export interface UseGroupEvents {
	events: Ref<EventV2[]>;
	status: Ref<STATUS>;
	isError: Ref<boolean>;
	isLoading: Ref<boolean>;
	isSuccess: Ref<boolean>;
	isUnstarted: Ref<boolean>;
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export const useGroupEvents = (currentGroupId: Ref<string>, onFetchCompleted = () => {}): UseGroupEvents => {
	const {
		track,
		status,
		isError,
		isLoading,
		isSuccess,
		isUnstarted,
	} = useAsyncStatus();
	const events: Ref<EventV2[]> = ref([]);
	const getAndSetEvents = async (token: CancelToken) => {
		const result = await getGroupEvents(currentGroupId.value, token);
		events.value = result;
	};
	const { search: throttledGetAndSetEvents } = useThrottledApi(getAndSetEvents, {
		shouldShortCircuit: () => false,
		emptyResultFactory: () => [],
		catchAndReturnEmptyOnCancellation: true,
	});
	const getGroupsEvents = async (curr: string, prev?: string) => {
		if (curr === prev || !curr) {
			return;
		}
		await track(throttledGetAndSetEvents());
		onFetchCompleted();
	};
	watch(currentGroupId, getGroupsEvents);
	getGroupsEvents(currentGroupId.value);

	return {
		events,
		status,
		isError,
		isLoading,
		isSuccess,
		isUnstarted,
	};
};
